import { isNil, round } from 'lodash';
import numeral from 'numeral';

import CustomNumberCellEditor from './localisedNumberCellEditor';
import { createValueFormatter, parseEditedNumber } from './numberUtils';

export const localeNumber = {
  format(value, format = '0,0.[00]') {
    return numeral(value).format(format);
  },
};

function getDecimalSeparator() {
  const currentLocale = numeral.options.currentLocale;

  return numeral.locales[currentLocale].delimiters.decimal;
}

export function numericColumn(overrides = {}) {
  const {
    decimalSeparator = getDecimalSeparator(),
    formatter = localeNumber,
    displayPrecision = 2,
    valuePrecision = 4,
    multiplier = 1,
    emptyValue = null,
    colDef = {},
  } = overrides;

  const valueFormatter = createValueFormatter({
    formatter,
    displayPrecision,
    multiplier,
  });

  return {
    type: 'numericColumnNew',
    filter: 'agNumberColumnFilter',
    comparator: (valueA, valueB) => {
      // We use string types to handle i18n - ag-grid needs to sort as numbers.
      return valueA - valueB;
    },
    filterValueGetter: ({ data, colDef: col }) => {
      const value = data?.[col.field];

      if (isNil(value)) {
        return null;
      }

      return round(value * multiplier, displayPrecision);
    },
    valueFormatter,
    valueParser: params =>
      parseEditedNumber({
        value: params.newValue,
        multiplier,
        decimalSeparator: decimalSeparator || getDecimalSeparator(),
        emptyValue,
        valuePrecision,
      }),
    cellStyle: {
      textAlign: 'right',
    },
    cellEditor: CustomNumberCellEditor,
    cellEditorParams: {
      multiplier,
      decimalSeparator: getDecimalSeparator(),
      emptyValue,
      valuePrecision,
      ...(colDef.cellEditorParams || {}),
    },
    ...colDef,
  };
}
